import { ORDER_FULFILLMENT_STATUSES, ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  [ORDER_METHODS.PICKUP]: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Your order has been cancelled.',
      description: 'Sorry, we can’t process your order right now.',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'We’ve received your order',
      description: 'Waiting for order confirmation...',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Your order has been seen',
      description: 'Waiting for order confirmation...',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'We’re getting your order ready',
      description: 'Your order is confirmed',
    },
    [ORDER_FULFILLMENT_STATUSES.PREPARING]: {
      title: 'Preparing your order',
      description: 'We are preparing your order',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Your order is ready and waiting for you!',
      description: 'Your order is ready for pickup.',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Your order is on its way!',
      description: 'Expect your order to arrive soon.',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Your order is ready!',
      description: 'Your order is ready for pickup.',
    },
  },
  [ORDER_METHODS.DELIVERY]: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Your order has been cancelled.',
      description: 'Sorry, we can’t process your order right now.',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'We’ve received your order',
      description: 'Waiting for order confirmation...',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Your order has been seen',
      description: 'Waiting for order confirmation...',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'We’re getting your order ready',
      description: 'Your order is confirmed',
    },
    [ORDER_FULFILLMENT_STATUSES.PREPARING]: {
      title: 'Preparing your order',
      description: 'We’ll let you know when it’s out for delivery',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Your order is on its way!',
      description: 'Expect your order to arrive soon.',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Your order is on its way!',
      description: 'Expect your order to arrive soon.',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Your order is ready!',
      description: 'Your order is ready.',
    },
  },
  [ORDER_METHODS.ROOM_SERVICE]: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Your order has been cancelled.',
      description: 'Sorry, we can’t process your order right now.',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'We’ve received your order',
      description: 'Waiting for order confirmation...',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Your order has been seen',
      description: 'Waiting for order confirmation...',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'We’re getting your order ready',
      description: 'Your order is confirmed',
    },
    [ORDER_FULFILLMENT_STATUSES.PREPARING]: {
      title: 'Preparing your order',
      description: 'We are preparing your order',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Your order is ready and waiting for you!',
      description: 'Your order is ready for pickup.',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Your order is on its way!',
      description: 'Expect your order to arrive soon.',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Your order is ready!',
      description: 'Your order is ready for pickup.',
    },
  },
  estimate: 'Estimate: {{time}}',
  today: 'Today',
};
